import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import Detail from './Detail';

const WaterBasinLine = () => {
  document.title = "Усны сав газрын хил";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Усны сав газар" breadcrumbItem="Усны сав газрын хил" />
          <Row>
            <Detail />
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default WaterBasinLine;